var HeighChart = require('highcharts');
var Moment = require('jalali-moment');

function generalSetting() {
	HeighChart.setOptions({
		chart: {
			style: {
				fontFamily: 'IRANSans(FaNum)'
			}
		},
		lang:{
			months: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
			shortMonths: ["فرو", "ارد", "خرد", "تیر", "مرد", "شهر", "مهر", "آبان", "آذر", "دی", "بهمن", "اسف"],
			weekdays: ["شنبه", "یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنج شنبه", "جمعه"],
			downloadCSV: 'دانلود فایل csv',
			downloadJPEG: 'دانلود فایل JPEG',
			downloadPDF: 'دانلود فایل PDF',
			downloadPNG: 'دانلود فایل PNG',
			downloadSVG: 'دانلود فایل SVG',
			loading: 'در حال بارگزاری...',
			noData: 'اطلاعاتی جهت نمایش در دسترس نیست.'
		},
	});
}

function sellerIndexChart() {
	var sellerIndex = new HeighChart.chart('chart', {
		chart: {
			renderTo: 'container',
			type: 'areaspline',
			spacingBottom: 20,
			spacingTop: 80,
			spacingLeft: 0,
			spacingRight: 0,
			marginLeft: 60,
			marginRight: 30,
			borderColor: '#E6E6E6',
			borderRadius: 5,
			borderWidth: 1,
		},
		title: {
			text: 'فروش این ماه / آذر ماه ۱۳۹۶',
			floating: true,
			align: 'right',
			verticalAlign: 'top',
			y: -40,
			x: -30
		},
		legend: {
			align: 'center',
			layout: 'horizontal',
			borderWidth: 0,
			rtl: true,
			itemDistance: 60,
			margin: 60,
			itemStyle: {
				"color": "#808080",
				"font-size": "1.188rem"
			}
		},
		xAxis: {
			// type: 'datetime',
			labels: {
				style: {
					color: "#B3B3B3",
					fontFamily: "'IRANSans(FaNum)'",
					fontSize: "1.188rem"
				},
				padding: 10,
				y: 30,
			},
			categories: [
				'2/3/96',
				'3/3/96',
				'4/3/96',
				'5/3/96',
				'6/3/96',
				'7/3/96'
			],
		},
		yAxis: {
			showEmpty: false,
			labels: {
				style: {
					color: "#B3B3B3",
					fontFamily: "'IRANSans(FaNum)'",
					fontSize: "14px"
				}
			},
			title: {
				text: ''
			}
		},
		tooltip: {
			shared: false,
			useHTML: true,
			style: {
				padding: 10,
				textAlign: 'right',
				fontFamily: "'IRANSans(FaNum)'",
				color: '#B3B3B3'
			},
			headerFormat: '<span style="color:{series.color}">{series.name}</span><br/>',
			formatter: function() {
				return '<span style="color:' + this.series.color + ';">' + this.series.name + '</span>' + '<br/>تعداد: ' + '<b style="color: #4d4d4d">' + this.y + '</b>' + '<br/>در تاریخ: ' + '<span style="color: #4d4d4d">' + this.x + '</span>';
			}
		},
		credits: {
			enabled: false
		},
		plotOptions: {
			areaspline: {
				fillOpacity: 0.5
			}
		},
		series: [{
			name: 'مجموع فروش',
			data: [ 8, 12, 23, 15, 17, 22],
			color: '#FEA000',
			fillColor: {
				linearGradient: [0, 0, 0, 600],
				stops: [
					[0, 'rgba(254,160,0,0)'],
					[1, 'rgba(254,160,0,0.2)']
				]
			},
			marker: {
				symbol: 'circle'
			}
		}, {
			name: 'تعداد سفارشات',
			data: [ 6, 8, 20, 12, 19, 16],
			color: '#95989A',
			fillColor: {
				linearGradient: [0, 0, 0, 600],
				stops: [
					[0, 'rgba(149,152,154,0)'],
					[1, 'rgba(149,152,154,0.2)']
				]
			},
			marker: {
				symbol: 'circle'
			}
		}]
	});
}

function analyzeChart() {
	var analyze = new HeighChart.chart('chart', {
		chart: {
			renderTo: 'container',
			type: 'areaspline',
			spacingBottom: 20,
			spacingTop: 80,
			spacingLeft: 0,
			spacingRight: 0,
			marginLeft: 60,
			marginRight: 30,
			borderColor: '#E6E6E6',
			borderRadius: 5,
			borderWidth: 1
		},
		title: {
			text: 'فروش این ماه / آذر ماه ۱۳۹۶',
			floating: true,
			align: 'right',
			verticalAlign: 'top',
			widthAdjust: 0,
			y: -40,
			x: -30
		},
		legend: {
			align: 'center',
			layout: 'horizontal',
			borderWidth: 0,
			rtl: true,
			itemDistance: 60,
			margin: 60,
			itemStyle: {
				"color": "#808080",
				"font-size": "1.188rem",
				"font-family": "IRANSansLight(FaNum)"
			}
		},
		xAxis: {
			labels: {
				style: {
					color: "#B3B3B3",
					fontFamily: "'IRANSans(FaNum)'",
					fontSize: "1.188rem"
				},
				padding: 10,
				y: 30,
			},
			categories: [
				'2/3/96',
				'3/3/96',
				'4/3/96',
				'5/3/96',
				'6/3/96',
				'7/3/96',
				'8/3/96',
				'9/3/96',
				'10/3/96',
				'11/3/96'
			]
		},
		yAxis: {
			showEmpty: false,
			title: {
				text: ''
			},
			labels: {
				style: {
					color: "#B3B3B3",
					fontFamily: "'IRANSans(FaNum)'",
					fontSize: "14px"
				}
			}
		},
		tooltip: {
			shared: false,
			useHTML: true,
			style: {
				padding: 10,
				textAlign: 'right',
				fontFamily: "'IRANSans(FaNum)'",
				color: '#B3B3B3'
			},
			headerFormat: '<span style="color:{series.color}">{series.name}</span><br/>',
			formatter: function() {
				return '<span style="color:' + this.series.color + ';">' + this.series.name + '</span>' + '<br/>تعداد: ' + '<b style="color: #4d4d4d">' + this.y + '</b>' + '<br/>در تاریخ: ' + '<span style="color: #4d4d4d">' + this.x + '</span>';
			}
		},
		credits: {
			enabled: false
		},
		plotOptions: {
			areaspline: {
				fillOpacity: 0
			}
		},
		series: [{
			name: 'مشاهده',
			data: [ 0, 15, 24, 8, 18, 30, 13, 18, 32, 17 ],
			color: '#5EC37D',
			marker: {
				symbol: 'circle'
			}
		}, {
			name: 'بازدید',
			data: [ 10, 1, 12, 28, 13, 25, 24, 5, 30, 12 ],
			color: '#65C0F0',
			marker: {
				symbol: 'circle'
			}
		}, {
			name: 'دسترسی',
			data: [ 5, 8, 25, 15, 25, 4, 12, 18, 10, 35 ],
			color: '#FEA000',
			marker: {
				symbol: 'circle'
			}
		}, {
			name: 'فروش',
			data: [ 15, 12, 25, 2, 14, 19, 10, 15, 20, 26 ],
			color: '#9F3FE5',
			marker: {
				symbol: 'circle'
			}
		}, {
			name: 'نرخ تبدیل',
			data: [ 0, 17, 6, 7, 18, 9, 28, 25, 21, 0],
			color: '#FF1A1A',
			marker: {
				symbol: 'circle'
			}
		}]
	});
}

$(function() {
	if ($('.page-analyze').length > 0) {
		generalSetting();
		analyzeChart();

	} else if ($('.page-seller').length > 0) {
		generalSetting();
		sellerIndexChart();
	}
});